var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeScanText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.786,
    height: 41.648,
    viewBox: "0 0 91.786 41.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M1585.576,2608.466l-12.558-16.8v-8.205a4.788,4.788,0,0,0-4.787-4.787h-69.655a4.788,4.788,0,0,0-4.787,4.787v32.075a4.787,4.787,0,0,0,4.787,4.786h69.655a4.787,4.787,0,0,0,4.787-4.786V2605.6l12.558,2.867Z",
    transform: "translate(-1493.79 -2578.67)",
    fill: "#e05a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M1523.055,2597.82c4.735,0,7.17,2.833,7.17,7.789v.973h-4.6V2605.3c0-2.214-.884-3.054-2.435-3.054s-2.435.84-2.435,3.054c0,6.371,9.514,7.568,9.514,16.418,0,4.956-2.479,7.79-7.258,7.79s-7.258-2.833-7.258-7.79v-1.9h4.6v2.214c0,2.214.973,3.01,2.523,3.01s2.524-.8,2.524-3.01c0-6.371-9.514-7.568-9.514-16.419,0-4.956,2.435-7.789,7.17-7.789Z",
    transform: "translate(-1510.037 -2592.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M1595.257,2617.6v4.116c0,4.956-2.476,7.789-7.258,7.789s-7.259-2.833-7.259-7.789V2605.61c0-4.956,2.479-7.789,7.259-7.789s7.258,2.833,7.258,7.789v3.01h-4.6v-3.32c0-2.214-.973-3.054-2.524-3.054s-2.523.84-2.523,3.054v16.728c0,2.214.973,3.01,2.523,3.01s2.524-.8,2.524-3.01V2617.6Z",
    transform: "translate(-1558.119 -2592.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M1660.055,2630.157h-4.912l-.84-5.619h-5.973l-.84,5.619h-4.47l4.956-30.977h7.125l4.956,30.977Zm-11.109-9.824h4.691l-2.347-15.667-2.347,15.667Z",
    transform: "translate(-1604.197 -2593.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M1721.381,2607.721v22.436H1717V2599.18h6.106l5,18.542V2599.18h4.337v30.977h-5Z",
    transform: "translate(-1658.93 -2593.844)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeScanText);
export default __webpack_public_path__ + "static/media/theme-scan-text.b7a483006abe5b98093ee67b9d6892ce.svg";
export { ForwardRef as ReactComponent };